package com.downdogapp.client

fun videoPlayer(loop: Boolean = false) =
  createMediaPlayer(true, loop)

fun audioPlayer(loop: Boolean = false) =
  createMediaPlayer(false, loop)
